import { ReactElement } from 'react';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import { TableSortLabel } from '@material-ui/core';

import Loader from '~/ui/components/common/Loader';
import NoDataFound from '~/ui/components/reusable/NoDataFound';
import Item from './Item';

import { IDevice } from '~/services/api/devices/types';
import { DeviceAction } from '../types';
import { headCells } from './constants';
import { ISort } from '~/utils/sort/types';
import { getSort } from '~/utils/sort';
import { Order } from '~/types';

interface IProps {
  devices: IDevice[];
  checkedDevicesIds: number[];
  isLoading: boolean;
  sort: ISort;
  setSort: (sort: ISort) => void;
  onToggleCheckDevice: (id: number) => void;
  onAction: (action: DeviceAction, devicesIds: number[]) => void;
}

const TableComponent = ({
  devices,
  checkedDevicesIds,
  isLoading,
  sort,
  setSort,
  onToggleCheckDevice,
  onAction,
}: IProps): ReactElement => {
  if (isLoading) return <Loader />;

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            {headCells.map(headCell => (
              <TableCell
                key={headCell.id}
                width={headCell.width}
                align={headCell.align || 'inherit'}
              >
                {headCell.useSort ? (
                  <TableSortLabel
                    active={sort.orderBy === headCell.id}
                    direction={
                      sort.orderBy === headCell.id && sort.isDescending ? Order.Desc : Order.Asc
                    }
                    onClick={() => setSort(getSort(sort, headCell.id))}
                  >
                    {headCell.label}
                  </TableSortLabel>
                ) : (
                  headCell.label
                )}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {devices.length ? (
            devices.map(item => (
              <Item
                key={item.id}
                device={item}
                checkedDevicesIds={checkedDevicesIds}
                onToggleCheckDevice={onToggleCheckDevice}
                onAction={onAction}
              />
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={9}>
                <NoDataFound />
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableComponent;
